import { Fragment } from 'react'

/**
 * Tira acento e caixa uma unidade UTF-16 por vez, para a posição no texto dobrado
 * ser a mesma do original. É a mesma regra da busca no servidor (`f_unaccent` +
 * `lower`): "orcamento" destaca "Orçamento".
 */
function fold(value: string): string {
    return value
        .split('')
        .map(unit => {
            const folded = unit.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
            return folded.length === 1 ? folded : unit
        })
        .join('')
}

interface HighlightedTextProps {
    text: string
    term?: string | null
    className?: string
}

/** Texto com todas as ocorrências do termo destacadas, ignorando acento e caixa. */
export function HighlightedText({ text, term, className }: HighlightedTextProps) {
    const needle = fold(term?.trim() ?? '')
    if (!needle) return <span className={className}>{text}</span>

    const haystack = fold(text)
    const parts: Array<{ value: string; match: boolean }> = []
    let cursor = 0
    let index = haystack.indexOf(needle)
    while (index >= 0) {
        if (index > cursor) parts.push({ value: text.slice(cursor, index), match: false })
        parts.push({ value: text.slice(index, index + needle.length), match: true })
        cursor = index + needle.length
        index = haystack.indexOf(needle, cursor)
    }
    if (cursor < text.length) parts.push({ value: text.slice(cursor), match: false })

    return (
        <span className={className}>
            {parts.map((part, i) =>
                part.match ? (
                    <mark key={i} className="bg-warning/40 text-base-content rounded-sm px-0.5">
                        {part.value}
                    </mark>
                ) : (
                    <Fragment key={i}>{part.value}</Fragment>
                ),
            )}
        </span>
    )
}
